import $ from 'jquery'
import calendar from 'hotwire/calendar'
import nav from 'hotwire/nav'
import pruneStoreRecords from 'hotwire/pruneStoreRecords'
import pusherStreams from 'hotwire/pusherStreams'
import refreshFrame from 'hotwire/refreshFrame'
import {Modal, Popover} from 'utils/bootstrap'
import {setupAsyncRolePersonDropdown} from './async_dropdown'

function animate(divId, animation) {
  const div = $(divId)
  const clear = () => { div.slideUp() }
  switch (animation) {
    case 'remain-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500)
      break
    case 'slide-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500, clear)
      break
    case 'slide-right':
      div.css({position: 'relative'})
      div.animate({left: '+=100%'}, 500, clear)
      break
    case 'slide-up':
      div.slideUp(() => removeElemOrContainer(div))
      break
    default:
      // Placate the linter
  }
}

function removeElemOrContainer(element) {
  if (!element)
    return false

  return element.remove()
}

function closeBsModal() {
  document.querySelectorAll('.modal').forEach((element) => Modal.getInstance(element)?.hide())

  // Clean up artifacts from any potential failure
  document.querySelectorAll('.modal-backdrop').forEach((element) => element.remove())
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
}

function enableBsPopovers(container) {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((element) => {
    Popover.getOrCreateInstance(element, {
      container,
      html: true,
      placement: 'bottom',
      trigger: 'click focus hover',
    })
  })
}

function enableFrogboxes(organizationId) {
  $('.hotwired-frogbox-toggle').on('click', (event) => {
    const frogbox = $(event.target).closest('.hotwired-frogbox-toggle').data('frogbox')
    const turboframe = document.getElementById(`frogbox-${frogbox}`)

    if (turboframe.childElementCount > 0)
      turboframe.innerHTML = ''
    else
      turboframe.setAttribute('src', `/organizations/${organizationId}/dialogs/frogbox/${frogbox}`)
  })
}

function refetchCalendarEvents() {
  if ($('#js-work-items-calendar').length && window.gf?.calendar)
    window.gf.calendar.refetchEvents()
}

function refreshWorkspaceFilters() {
  ['workspace-role-filter', 'workspace-tag-filter'].forEach((frameID) => {
    if (document.getElementById(frameID))
      refreshTurboFrame(frameID)
  })
}

function refreshAfterMutation(frameID = 'page-frame', refreshUrl = document.location) {
  let refreshedPageFrame = false

  if (refreshUrl === null) {
    const refreshTarget = document.getElementById(frameID)
    if (refreshTarget && (refreshTarget.src || refreshTarget.dataset.refreshUrl)) {
      refreshTurboFrame(frameID)
    } else {
      refreshTurboFrame('page-frame', document.location)
      refreshedPageFrame = true
    }
  } else if (refreshUrl) {
    refreshTurboFrame(frameID, refreshUrl)
    refreshedPageFrame = frameID === 'page-frame'
  } else {
    refreshTurboFrame(frameID)
    refreshedPageFrame = frameID === 'page-frame'
  }

  if (!refreshedPageFrame && document.getElementById('workspace-frame'))
    refreshWorkspaceFilters()
}

function refreshTurboFrame(frameID, src = null) {
  const turboFrame = document.getElementById(frameID)
  if (!turboFrame)
    return

  if (src)
    turboFrame.dataset.refreshUrl = src

  const url = src || turboFrame.dataset.refreshUrl || turboFrame.src
  if (url)
    refreshFrame(turboFrame, url)
}

export default
{animate,
  calendar,
  closeBsModal,
  enableBsPopovers,
  enableFrogboxes,
  nav,
  pruneStoreRecords,
  pusherStreams,
  refreshAfterMutation,
  refetchCalendarEvents,
  refreshWorkspaceFilters,
  refreshTurboFrame,
  setupAsyncRolePersonDropdown}
